import axios from 'axios';

const basePath = '/api/delivery/routes';

export const routeService = {
  // Obtener lista completa de rutas activas
  getRoutes: async () => {
    const response = await axios.get(`${basePath}/`);
    return response.data;
  },

  // Crear nueva ruta
  createRoute: async (routeData) => {
    const response = await axios.post(`${basePath}/`, routeData);
    return response.data;
  },

  // Actualizar ruta (PATCH)
  updateRoute: async (id, routeData) => {
    const response = await axios.patch(`${basePath}/${id}/`, routeData);
    return response.data;
  },

  // Eliminar (desactivar) ruta
  deleteRoute: async (id) => {
    const response = await axios.delete(`${basePath}/${id}/`);
    return response.data;
  }
};

export default routeService;
